import { i18n } from "@/shared/i18n"

import { isSupportedLanguage } from "./type-guards"

/** The key the i18next detector reads on a cold start; writes are ours, the detector's own cache is off. */
const PERSISTED_LANGUAGE_KEY = "i18nextLng"

interface ApplyLanguageOptions {
  /** Cache the resolved language for the next cold start. */
  persist?: boolean
}

const persistLanguage = (lng: string) => {
  try {
    localStorage.setItem(PERSISTED_LANGUAGE_KEY, lng)
  } catch {
    // Private mode or quota: the next start simply re-resolves the language.
  }
}

export const applyLanguageIfDifferent = (lng: string, { persist = true }: ApplyLanguageOptions = {}) => {
  if (!isSupportedLanguage(lng)) return
  if (persist) persistLanguage(lng)
  if (!i18n.isInitialized) {
    // i18next-fluent only builds bundles for namespaces added after init, so a language switched mid-init has no strings.
    const onInitialized = () => {
      i18n.off("initialized", onInitialized)
      applyLanguageIfDifferent(lng, { persist: false })
    }
    i18n.on("initialized", onInitialized)
    return
  }
  if (i18n.language !== lng) {
    void i18n.changeLanguage(lng)
  }
}
